(() => {
  const button = document.querySelector('[data-back-to-top]');
  if (!button) return;

  const threshold = 300;

  const toggleVisibility = () => {
    const shouldShow = (window.scrollY || document.documentElement.scrollTop) > threshold;
    button.classList.toggle('is-visible', shouldShow);
  };

  button.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  window.addEventListener('scroll', toggleVisibility, { passive: true });
  toggleVisibility();
})();
